export const SCREENS = {
  DATE: 0,
  SLOT: 1,
};

export const TIME_RANGE_TYPES = {
  DAY: 'day',
  MONTH: 'month',
};
